import { css } from '@emotion/css';

export const closeIconStyles = css`
  width: 1.6rem !important;
  height: 1.6rem !important;
`;
